<div class="alignment">
  <fa-icon [icon]="faGlobe" class="languageIcon" size="sm" (click)="openLanguageSelect($event)"></fa-icon>
</div>
<div class="alignment">
  @if (useLanguageCode) {
    <ion-select
      [value]="language"
      interface="popover"
      placeholder="{{ 'GENERAL.SELECT_LANGUAGE' | translate }}"
      id="inputSelectedLanguage"
      [selectedText]="selectedLanguage(language)"
      #inputSelectedLanguage
      (ionChange)="changeLanguage($event.detail.value)"
    >
      <ion-select-option value="de" id="inputSelectedLanguagede">
        DE - {{ "GENERAL.GERMAN" | translate }}
      </ion-select-option>
      <ion-select-option value="en" id="inputSelectedLanguageen">
        EN - {{ "GENERAL.ENGLISH" | translate }}
      </ion-select-option>
      <ion-select-option value="fr" id="inputSelectedLanguagefr">
        FR - {{ "GENERAL.FRENCH" | translate }}
      </ion-select-option>
      <ion-select-option value="es" id="inputSelectedLanguagees">
        ES - {{ "GENERAL.SPANISH" | translate }}
      </ion-select-option>
      <ion-select-option value="ca" id="inputSelectedLanguageca">
        CA - {{ "GENERAL.CATALAN" | translate }}
      </ion-select-option>
      <ion-select-option value="ro" id="inputSelectedLanguagero">
        RO - {{ "GENERAL.ROMANIAN" | translate }}
      </ion-select-option>
    </ion-select>
  } @else {
    <ion-select
      [value]="language"
      interface="popover"
      placeholder="{{ 'GENERAL.SELECT_LANGUAGE' | translate }}"
      id="inputSelectedLanguage"
      #inputSelectedLanguage
      (ionChange)="changeLanguage($event.detail.value)"
    >
      <ion-select-option value="de" id="inputSelectedLanguagede">
        {{ "GENERAL.GERMAN" | translate }}
      </ion-select-option>
      <ion-select-option value="en" id="inputSelectedLanguageen">
        {{ "GENERAL.ENGLISH" | translate }}
      </ion-select-option>
      <ion-select-option value="fr" id="inputSelectedLanguagefr">
        {{ "GENERAL.FRENCH" | translate }}
      </ion-select-option>
      <ion-select-option value="es" id="inputSelectedLanguagees">
        {{ "GENERAL.SPANISH" | translate }}
      </ion-select-option>
      <ion-select-option value="ca" id="inputSelectedLanguageca">
        {{ "GENERAL.CATALAN" | translate }}
      </ion-select-option>
      <ion-select-option value="ro" id="inputSelectedLanguagero">
        {{ "GENERAL.ROMANIAN" | translate }}
      </ion-select-option>
    </ion-select>
  }
</div>
